/**
 * Add components by event and in your desired order
 * @type {[*]}
 */
let components = [
    [
        "ready",
        [
            require("./../components/equal-heights"),
            require("./../components/cookie-notice"),
            require("./../components/general"),
            require("./../components/form"),
            require("./../components/scroller"),
            require("./../components/trigger"),
            require("./../components/filter"),
            require("./../components/slider"),
            require("./../components/waypoints"),
            require("./../components/popup"),
            require("./../components/menu"),
            require("./../components/floating-link"),
            require("./../components/product-category-transition"),
            require("./../components/product-view-switch"),
            require("./../components/play-media"),
            require("./../components/video-player"),
            require("./../components/vc-timeline-image-gallery"),
            require("./../components/timeline"),
        ],
    ],
];

module.exports = components;
